/* eslint-disable max-len */
import React from 'react'; 
import Styles from './spinner.css'; 

const Spinner = () => {
  return (
    <div className={Styles.ldsspinner}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  );
};


export default Spinner; 
